module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-vitamix-e3047764c2446d9432fc878423ca86a8.svg";